import { invalidateCachedFetch } from '@structural-climbing/auth'

/**
 * Everything a logged, edited or deleted ascent makes wrong.
 *
 * The cache is stale-while-revalidate on a 30 second TTL, which is right for a
 * screen you keep returning to and wrong the instant you change the underlying
 * data yourself: log a route, open Progress, and it would show you the totals
 * from before you climbed it.
 *
 * Kept next to the request that does the writing rather than at each call site,
 * because gym routes and competition routes both log through the same sheet and
 * the list of affected keys should only exist once.
 */
export function invalidateAfterAscent() {
  // Your totals, and the chart drawn from them.
  invalidateCachedFetch('ascent-stats:')
  // Your score, and therefore everyone's position below you. The key carries
  // the period and gender, so the prefix has to cover all of them.
  invalidateCachedFetch('standings:')
  // Today's session on Home: the tops list, the count, the recap.
  invalidateCachedFetch('my-session:')
  // The routes in Home's "Log TOP" picker, with whether each is topped.
  invalidateCachedFetch('unclimbed-routes:')
}
